import { render, staticRenderFns } from "./vnCamelPay.vue?vue&type=template&id=a41aaf1a&scoped=true"
import script from "./vnCamelPay.vue?vue&type=script&lang=js"
export * from "./vnCamelPay.vue?vue&type=script&lang=js"
import style0 from "./vnCamelPay.vue?vue&type=style&index=0&id=a41aaf1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a41aaf1a",
  null
  
)

export default component.exports